import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { EchoNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-echo',
  imports: [ReactiveFormsModule, TranslatePipe],
  templateUrl: './edit-echo.component.html',
  styleUrl: './edit-echo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditEchoComponent,
    },
  ],
})
export class EditEchoComponent implements OnInit, NodeEditTab {
  public selectedNodeForEdit = input<SelectedNodeForEdit<EchoNodeData>>();
  public disableForm = input<boolean>(false);

  public form!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private translateService: TranslateService,
  ) { }

  public ngOnInit(): void {
    this.form = this.fb.group({
      name: [
        this.selectedNodeForEdit()?.data?.name ??
        this.translateService.instant('FLOW_CHART.NODES.ECHO.NAME'),
        [Validators.required],
      ],
    });
  }
}
